import React, { Component } from 'react'
import axios from 'axios'
import { Modal, Button, Table, Spin, message } from 'antd'
import PriorityManagementModal from './PriorityManagementModal'

const PRIORITY_LABEL = {
  100: 'Priority 1 (100%)',
  70: 'Priority 2 (70%)',
  50: 'Priority 3 (50%)',
  40: 'Priority 4 (40%)',
}

class PrioritySettingPage extends Component {
  state = {
    summaryData: [],
    loading: false,
    managementVisible: false,
    editData: null, // null = add mode, object = edit mode
  }

  _isMounted = false

  componentDidMount() {
    this._isMounted = true
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.fetchSummary()
    }
  }

  fetchSummary = () => {
    this.setState({ loading: true })
    axios
      .post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/plant-silo-priority/summary`,
        {},
        { headers: { Authorization: `Bearer ${this.props.accessToken}` } }
      )
      .then((res) => {
        if (this._isMounted) {
          this.setState({ summaryData: res.data.data || [], loading: false })
        }
      })
      .catch(() => {
        if (this._isMounted) {
          this.setState({ loading: false })
          message.error('โหลดข้อมูลไม่สำเร็จ')
        }
      })
  }

  handleAdd = () => {
    this.setState({ editData: null, managementVisible: true })
  }

  handleEdit = (record) => {
    this.setState({
      editData: {
        priorityValue: record.auto_order_priority,
        materialId: record.material_id,
        materialCode: record.material_code,
        materialName: record.material_name,
      },
      managementVisible: true,
    })
  }

  handleManagementClose = () => {
    this.setState({ managementVisible: false, editData: null })
    this.fetchSummary()
  }

  render() {
    const { visible, onClose, accessToken } = this.props
    const { summaryData, loading, managementVisible, editData } = this.state

    const columns = [
      {
        title: 'วัตถุดิบ',
        dataIndex: 'material_name',
        key: 'material_name',
        render: (_, record) => `(${record.material_code}) ${record.material_name}`,
      },
      {
        title: 'Priority',
        dataIndex: 'auto_order_priority',
        key: 'auto_order_priority',
        render: (val) => PRIORITY_LABEL[val] || val,
      },
      {
        title: 'จำนวนโรงงาน',
        dataIndex: 'plant_count',
        key: 'plant_count',
        render: (val) => val,
      },
      {
        title: '',
        key: 'action',
        render: (_, record) => (
          <Button size='small' onClick={() => this.handleEdit(record)}>
            แก้ไข
          </Button>
        ),
      },
    ]

    return (
      <>
        <Modal
          title='ตั้งค่า Priority ของแต่ละโรงงาน'
          visible={visible}
          onCancel={onClose}
          width={800}
          footer={[
            <Button key='close' onClick={onClose}>
              ปิด
            </Button>,
          ]}
        >
          <div style={{ textAlign: 'right', marginBottom: 12 }}>
            <Button type='primary' icon='plus' onClick={this.handleAdd}>
              เพิ่ม
            </Button>
          </div>
          <Spin spinning={loading}>
            <Table
              dataSource={summaryData}
              columns={columns}
              rowKey={(r) => `${r.material_id}_${r.auto_order_priority}`}
              pagination={false}
              size='small'
            />
          </Spin>
        </Modal>

        <PriorityManagementModal
          visible={managementVisible}
          onClose={this.handleManagementClose}
          accessToken={accessToken}
          initialData={editData}
        />
      </>
    )
  }
}

export default PrioritySettingPage
